import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

export function Breadcrumb({ items }) {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {items.map((item, index) => (
          <li key={item.href} className="flex items-center">
            {index > 0 && (
              <FaChevronRight className="mx-2 h-3 w-3 flex-shrink-0 text-gray-500" aria-hidden="true" />
            )}
            {index === items.length - 1 ? (
              <span className="text-sm font-medium text-gray-100">{item.name}</span>
            ) : (
              <Link
                to={item.href}
                className="text-sm font-medium text-blue-400 hover:text-blue-300 transition-colors duration-150"
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
